import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import ReactHowler from 'react-howler'
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import raf from 'raf';
import { Theme } from '../../config/theme.js';
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import { request, guid, mapStateToProps, mapDispatchToProps } from '../../utils';
import { nextSong, previousSong, play, pause } from '../../actions/player';

import TrackControl from '../TrackControl';
import TrackProgress from '../TrackProgress';
import VolumeControl from '../VolumeControl';
import CurrentTrack from '../CurrentTrack';

class MusicPlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      playing: true,
      seconds: 0,
      duration: 0,
      muted: false,
      volume: 1,
      loaded: false,
    };

    this.handleOnLoad = this._loaded.bind(this);
    this.handleOnPlay = this._handleOnPlay.bind(this);
    this.handleOnEnd = this._handleOnEnd.bind(this);
    this.renderSeekPos = this.renderSeekPos.bind(this);
    this.handleStop = this._handleStop.bind(this)
  }

  componentDidUpdate(prevProps, prevState) {
    if (isBrowser) {
      if(this.state.loaded && prevProps.player.queue != this.props.player.queue) {
        // this.handleOnPlay();
        // this.renderSeekPos();
        setTimeout(() => {
          this.startRaf();
        }, 5000);
      }

      if(!this.state.loaded) {
        this.setState({
          loaded: true,
        });
        setTimeout(() => {
          this.props.dispatch(play());
          this.props.dispatch(pause());
          this.props.dispatch(play());
          this.props.dispatch(pause());
        }, 1000);
      }

      if(prevProps.player.position != this.props.player.position) {
        this.props.dispatch(play());
      }
    }
  }

  componentWillUnmount() {
    this.clearRAF();
  }

  _loaded() {
    this.setState({
      // playing: false,
      loadState: this.player.howlerState(),
      loaded: true,
      duration: this.player.duration(),
    });
  }

  clearRAF() {
    raf.cancel(this._raf);
  }

  _handleOnPlay() {
    this.props.dispatch(play());
    this.renderSeekPos();
    this.startRaf();
  }

  _handleStop() {
    this.player.stop();
    this.props.dispatch(pause());
    this.renderSeekPos();
  }

  renderSeekPos() {
    if (this.player && this.player.seek()) {
      const seek = this.player.seek();
      const timeRemaining = Math.ceil(this.state.duration - this.state.seek);

      this.setState({
        seek,
      });
      if (this.props.player.music_playing) {
        this.startRaf();
      }


      if (timeRemaining <= 10 && timeRemaining !== this.props.player.time_remaining) {
        this.props.dispatch({
          type: "SET_TIME_REMAINING",
          payload: timeRemaining,
        });
      }
    }
  }

  startRaf() {
    this._raf = raf(this.renderSeekPos);
  }

  _handleOnEnd() {
    if(this.props.player.queue.length > (this.props.player.position + 1)) {
      this.props.dispatch(nextSong());
    } else {
      this._handleStop();
    }

    this.clearRAF()
  }

  _togglePlay() {
    const playing = !this.props.player.music_playing;
    if(playing) {
      this.handleOnPlay();
    } else {
      this.props.dispatch(pause());
    }
  }

  _toggleMute() {
    const muted = !this.state.muted;
    this.setState({
      muted: muted,
    });
  }

  _seek(value) {
    if(!this.props.player.music_playing) {
      this.handleOnPlay();
    }

    if (this.player) {
      this.player.seek(value);
    }
  }

  _setVolume(volume) {
    this.setState({
      volume: volume,
    });
  }

  _previousSong() {
    this.props.dispatch(previousSong());
  }

  _nextSong() {
    this.props.dispatch(nextSong());
  }

  render() {
    if(!Theme.player.enabled || !this.props.player.queue || this.props.player.queue.length === 0) {
      return false;
    }

    return isBrowser ? (
      <div className={css(styles.container)}>
        <ReactHowler
          preload={false}
          html5={true}
          loop={false}
          ref={(ref) => (this.player = ref)}
          src={this.props.player.queue[this.props.player.position].stream_url}
          playing={this.props.player.music_playing}
          mute={!this.props.player.music_playing || this.state.muted}
          volume={this.state.volume}
          onLoad={() => {
            this.handleOnLoad();
          }}
          onEnd={this.handleOnEnd}
        />
        <div className={css(styles.content_container)}>
          <TrackControl
            handler={this._previousSong.bind(this)}
            type='previous'
            visible={this.props.player.position > 0} />
          <TrackControl
            type={!this.props.player.music_playing ? 'play' : 'pause'}
            handler={this._togglePlay.bind(this)} />
          <TrackControl
            handler={this._nextSong.bind(this)}
            type='next'
            visible={(this.props.player.position + 1) < this.props.player.queue.length} />
          <TrackProgress
            time={(this.state.seek !== undefined) ? this.state.seek : 0}
            length={this.state.duration}
            handler={this._seek.bind(this)} />
          <VolumeControl
            volume={!this.state.muted && this.state.volume ? this.state.volume : 0}
            toggleMute={this._toggleMute.bind(this)}
            handler={this._setVolume.bind(this)} />
          <CurrentTrack {...this.props.player.queue[this.props.player.position]} />
        </div>
      </div>
    ) : false;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MusicPlayer);

const styles = StyleSheet.create({
  container: {
    position: 'fixed',
    'user-select': 'none',
    cursor: 'default',
    left: 0,
    bottom: 0,
    width: '100vw',
    height: Theme.player.height,
    zIndex: Theme.player.zIndex,
    backgroundColor: Theme.white,
    borderTop: `1px solid ${Theme.border_color}`,
    [Theme.mobile_query]: {
      // display: 'none',
    },
  },
  content_container: {
    display: 'flex',
    height: '100%',
    alignItems: 'center',
    width: Theme.container_width,
    margin: '0 auto',
  },
})



// WEBPACK FOOTER //
// ./src/components/MusicPlayer/index.js